import { render, staticRenderFns } from "./article3.vue?vue&type=template&id=17d57597&scoped=true&lang=html&"
import script from "./article3.vue?vue&type=script&lang=js&"
export * from "./article3.vue?vue&type=script&lang=js&"
import style0 from "./article3.vue?vue&type=style&index=0&id=17d57597&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d57597",
  null
  
)

export default component.exports